import React, { Component } from "react";
import Item from "./PreviewItem";

class FileList extends Component {
  constructor(props) {
    super(props)

    this.state = { showAll: false }
  }

  activeAttachments = () => {
    if(this.state.showAll) { return this.props.attachments}

    return this.props.attachments.slice(0, 4)
  }

  get isShowMoreApplicable() {
    return this.props.attachments && this.props.attachments.length > 4
  }

  setShowAll = () => {
    this.setState((prevState, props) =>{
      return {showAll: !prevState.showAll}
    })
  }

  renderShowMoreButton = () => {
    if (!this.isShowMoreApplicable) { return }

    let spanText = `Show All Pages (${ this.props.attachments.length})`
    let iconText = "arrow_drop_down"

    if (this.state.showAll) {
      spanText = "Hide"
      iconText = "arrow_drop_up"
    }

    return (
      <button className="ds-btn _link _withIcon --small --block" onClick={this.setShowAll}>
        <span className="text"> {spanText } </span>
        <i className="materialIcon --micro"> {iconText} </i>
      </button>
    )
  }

  render() {
    return (
      <section className="_addDepth">
        <ul className="imageThumbs">
          {
            this.activeAttachments().map((item, i) => {
              return <Item
                key={i}
                attachment={item}
                onRemove={ !this.props.showMore && this.onRemove}
                disableAction={this.props.disableAction}
              />;
            })
          }
        </ul>
        { this.renderShowMoreButton() }
      </section>
    )
  }
}

export default FileList;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/FileList.js